export const TRAINING_STATUS = {
  COMPLETED: 'completed',
  NOT_COMPLETED: 'notCompleted',
  PARTIALLY_COMPLETED: 'partiallyCompleted',
  UNKNOWN: 'unknown',
} as const

export const POLICY_STATUS = {
  SIGNED: 'signed',
  NOT_SIGNED: 'not_signed',
} as const

export const EDR_AGENT_STATUS = {
  INSTALLED: 'installed',
  NOT_INSTALLED: 'not_installed',
} as const

export const EMPLOYEE_DASHBOARD_URL = '/people/employee-dashboard'

export const SAAS_MANAGEMENT_URL = '/people/saas-management'

export const DEPARTMENT_NAME_MAX_LENGTH = 255

export const EMPLOYEE_DASHBOARD_PARAMS = {
  AGENT: 'agent',
  SEARCH: 'search',
} as const
